import styled from "styled-components";

export const Portait2Style = styled.div`
.flex-column {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}

.flex-row-center {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}

.flex-row-left {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: left;
  justify-content: left;
}

.subflex-left {
  width: 100%;
  text-align: left;
}

.subflex-right {
  width: 100%;
  text-align: right;
}

.subflex-center {
  width: 100%;
  text-align: center;
}
.t2-mob-text-wrapper {
  white-space: pre-wrap;
}
/*.f-arial {*/
/*	font-family: Arial;*/
/*}*/

/*.f-mvboli {*/
/*	font-family: mvboli;*/
/*}*/

/*.f-nexalight {*/
/*	font-family: nexalight;*/
/*}*/

/*.f-nexabold {*/
/*	font-family: nexabold;*/
/*}*/

.f-cyan {
  color: #00fffc;
}

.f-cyan-dark {
  color: #00d1cf;
}

.f-blue {
  color: #005596;
}

.f-white {
  color: #ffffff;
}

.poster {
  position: relative;
  overflow: hidden !important;
}

.poster.nine-by-sixteen {
  width: 1080px;
  height: 1920px;
}

.poster.one-by-one {
  width: 310px;
  height: 310px;
}

.poster.nine-by-sixteen {
  width: 171px;
  height: 304px;
}

.poster.nine-by-sixteen .bg.two {
  position: absolute;
  height: 140%;
  width: 140%;
  top: -25%;
}

.poster .bg.two::after {
  position: absolute;
  content: "";
  height: 100%;
  width: 100%;
  background-color: rgba(0, 85, 150, 0.4);
}

.poster-content.two {
  overflow: hidden;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: #005596;
}

.poster-content.two::after {
  position: absolute;
  content: "";
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background-color: #00fffc;
}



.t2-mob-text-wrapper div {
  width: 90%;
}

.poster-content.two .ta {
  margin: 0 -100% 0 0;
  text-align: right;
}

.poster.nine-by-sixteen .poster-content.two .ta {
  font-size: 72px;
  line-height: 87px;
}

.poster.nine-by-sixteen .poster-content.two .ta {
  font-size: 10px !important;
  line-height: 12px;
}

.poster.nine-by-sixteen .bg.two {
  background-position: -120px center;
}

.poster-content.two::after {
  height: 10px;
}
  .text-wrappers{
    position:absolute;
    width:100%;
    height:100%
  }

  .text-wrappers > div {
    width:100%;
    overflow: hidden;
  }
  
`;
